export default "__VITE_ASSET__031a6cff__"